/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { createContext } from 'react'
import { noop } from 'lodash'

import type { LDContext } from 'launchdarkly-react-client-sdk'

export interface LaunchDarklyContextProps {
  clientInitialized: boolean
  clientInitializationFailed: boolean
  isIdentifying: boolean
  identify: (context: LDContext) => Promise<void>
  setIsAnonymous: (value: boolean) => void
}

export const LaunchDarklyContext = createContext<LaunchDarklyContextProps>({
  clientInitialized: false,
  isIdentifying: false,
  clientInitializationFailed: false,
  identify: () => Promise.resolve(),
  setIsAnonymous: noop,
})
